<form ngNoForm action="{{ providerURL }}" (submit)="onSubmit()" method="POST" class="social-login-form">
    <button nz-button nzType="primary" type="submit">
        {{ provider }}
        <i nz-icon nzType="{{ provider }}" nzTheme="outline" style="font-size: 1.5rem"></i>
    </button>
    <input name="scope" type="hidden" value="{{ providerSetting }}"/>
    <input name="_csrf" type="hidden" value="{{ csrf }}"/>
</form>
